export default __webpack_public_path__ + "87faa027345ec229689015995e7bde27.png";